import _ from 'lodash';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import MockUpUtil from 'gw-portals-util-js/MockUpUtil';

const fn = (LocaleService, $filter, $scope, StateUtils, LoadSaveService, $window, submissionViewModel, EventHub) => {
    const ctrl = Object.create(BaseCtrl);
    const flowModel = StateUtils.activeDataForState(true).flowModel;
    const submissionVM = submissionViewModel();

    ctrl.init = () => {
        const offeredQuotes = _.get(submissionVM.value, 'quoteData.offeredQuotes', []);
        $scope.page = {
            offeredQuotes,
            offeringLabels: ctrl._setOfferingLabels(offeredQuotes),
            baseOffering: ctrl._setBaseOffering(offeredQuotes),
            submission: submissionVM
        };
        window.producerCodeCountry = submissionVM.baseData.accountHolder.producerCodeCountry.value;

        const mockUpUtil = new MockUpUtil();
        const contactPhoneMockupData = mockUpUtil.getMockData('bindData.contactPhone');
        const mockedVM = submissionVM.value;
        _.defaults(mockedVM.bindData, {contactPhone: contactPhoneMockupData});
        submissionVM.value = mockedVM;

        $scope.showQuoteStartDateInHeader = !!ApplicationFeatures.getAllFeatures().showQuoteStartDateInHeader;
    };

    ctrl.printQuote = () => {
        EventHub.publish('wizard', 'print');
        $window.print();
    };

    ctrl.setSelectedQuote = (quote) => {
        if (quote.branchCode === 'CUSTOM' || quote.branchCode.indexOf('Version') === 0) {
            $scope.$broadcast('CustomQuoteSelected', [quote.publicID]);
        }
    };

    ctrl.getCustomQuoteHeaderCostString = () => {
        return `${LocaleService.getLocaleInfo().currency.symbol}?`;
    };

    ctrl.buy = (selectedQuote, numberOfPayments) => {
        // stash some bind information in state data so it can be accessed later when we call the bind method
        StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
        StateUtils.activeDataForState(true).chosenQuote = selectedQuote.publicID;
        flowModel.next(submissionVM);
    };

    ctrl.error = (data) => {
        flowModel.jumpToExit('error', data);
    };

    ctrl._setOfferingLabels = (standardOfferings) => {
        return standardOfferings.map((offering) => {
            return $filter('translate')(`quoteandbind.controllers.QuoteDetails.${offering.branchCode}`);
        });
    };

    ctrl._setBaseOffering = (standardOfferings) => {
        if (angular.isArray(standardOfferings) && standardOfferings.length === 1) {
            return standardOfferings[0];
        } else if (angular.isArray(standardOfferings) && standardOfferings.length > 1) {
            return standardOfferings[1];
        }
    };
    $scope.isCovNotavaliable =  () => {
                return _.get($scope.page, 'offeredQuotes[0]') === undefined && _.get(submissionVM.value, 'quoteData.offeredQuotes', []).length == 0 ;
    }
    return ctrl.create($scope);
};
fn.$inject = ['LocaleService', '$filter', '$scope', 'StateUtils', 'qnb.LoadSaveService', '$window', 'submissionViewModel', 'EventHub'];

export default fn;